import React, { useState, useEffect } from "react";
import { Grid, styled, ButtonBase } from "@mui/material";
import Amethyst from "../../assets/images/GemsImage/icon_amethyst.png";
import Aquamarine from "../../assets/images/GemsImage/icon_aquamarine.png";
import Emerald from "../../assets/images/GemsImage/icon_emerald.png";
import Garnet from "../../assets/images/GemsImage/icon_garnet.png";
import Morganite from "../../assets/images/GemsImage/icon_morganite.png";
import Other from "../../assets/images/GemsImage/icon_other_gems.png";
import Ruby from "../../assets/images/GemsImage/icon_ruby.png";
import Sapphire from "../../assets/images/GemsImage/icon_sapphire.png";
import Tanzanite from "../../assets/images/GemsImage/icon_tanzanite.png";
import Topaz from "../../assets/images/GemsImage/icon_topaz.png";
import Tourmaline from "../../assets/images/GemsImage/icon_tourmaline.png";

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  width: "100%",
  aspectRatio: "1 / 1",
  position: "relative",
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "10px",
  borderColor: "transparent",
  overflow: "hidden",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "10px",
  },
}));

const imageMap = {
  Amethyst,
  Aquamarine,
  Emerald,
  Garnet,
  Morganite,
  Other,
  Ruby,
  Sapphire,
  Tanzanite,
  Topaz,
  Tourmaline,
};

export const GemstoneTypes = ({ filter, searchQuery, dispatch }) => {
  const gemstones = filter.values || [];
  const [selectedGemstones, setSelectedGemstones] = useState([]);
  function handleOnClick(filterName, valueName) {
    let newFields = searchQuery.fields.map((field) => ({
      ...field,
      values: [...field.values],
    }));

    const searchFieldIndex = newFields.findIndex(
      (field) => field.name === filterName
    );
    if (searchFieldIndex > -1) {
      const searchField = newFields[searchFieldIndex];
      const valueFound = searchField.values.find(
        (value) => value.name === valueName
      );

      if (valueFound) {
        searchField.values = searchField.values.filter(
          (value) => value.name !== valueName
        );

        if (searchField.values.length === 0) {
          newFields = newFields.filter((field) => field.name !== filterName);
        } else {
          newFields[searchFieldIndex] = searchField;
        }
        dispatch({ type: "updateSearchQuery", payload: newFields });
      } else {
        searchField.values = [...searchField.values, { name: valueName }];
        newFields[searchFieldIndex] = searchField;
        dispatch({ type: "updateSearchQuery", payload: newFields });
      }
    } else {
      const newSearchFields = [
        ...newFields,
        { name: filterName, values: [{ name: valueName }] },
      ];
      dispatch({ type: "updateSearchQuery", payload: newSearchFields });
    }

    setSelectedGemstones((prev) =>
      prev.includes(valueName)
        ? prev.filter((name) => name !== valueName)
        : [...prev, valueName]
    );
  }
  useEffect(() => {
    if (searchQuery) {
      const gemstoneField = searchQuery.fields.find(
        (field) => field.name === "Gemstone"
      );
      const gemstoneName = gemstoneField
        ? gemstoneField.values.map((value) => value.name)
        : [];
      setSelectedGemstones(gemstoneName);
    }
  }, [searchQuery]);

  return (
    <Grid container gap={1} marginBottom="1rem" flexWrap="wrap">
      {gemstones.map((gemstone) => {
        const gemstoneName = gemstone.name;
        const isSelected = selectedGemstones.includes(gemstoneName);
        return (
          <Grid item key={gemstoneName} xs={3} lg={2} xl={1}>
            <ImageButton
              onClick={() => handleOnClick("Gemstone", gemstoneName)}
              sx={{
                border: isSelected
                  ? "2px solid lightBlue"
                  : "2px solid transparent",
                boxShadow: isSelected ? "0 0 8px lightBlue" : "transparent",
                background: isSelected ? "lightBlue" : "transparent",
              }}
            >
              <img src={imageMap[gemstoneName]} alt={gemstoneName} />
            </ImageButton>
          </Grid>
        );
      })}
    </Grid>
  );
};
